import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../entertainmentOption/EntertainmentOption.scss';

const ArrivalTimeOption = ({
  label = '',
  checked = false,
  color = '',
  areSpacesAvailable = true,
  disabled = false,
  onOptionClick,
  isAlreadyBooked = false,
}) => (
  <div
    className={classnames('option', checked && 'checked', color && color, disabled && 'grey-background')}
    onClick={onOptionClick}
  >
    {!!label && <div className="option-label">{label}</div>}
    {!checked && !areSpacesAvailable && !isAlreadyBooked && (
      <div className="option-no-spaces">No spaces available</div>
    )}
    {isAlreadyBooked && (
      <div className="option-no-spaces">Already booked</div>
    )}
  </div>
);

ArrivalTimeOption.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onOptionClick: PropTypes.func.isRequired,
  areSpacesAvailable: PropTypes.bool,
  isAlreadyBooked: PropTypes.bool,
};

export default ArrivalTimeOption;
